import Vue from 'vue'
import App from './App.vue'

window.$ = window.jQuery = require('jquery');
require('semantic-ui-css/semantic.min.css');
require('semantic-ui-css/semantic.min.js');
import { store } from './store'
import './registerServiceWorker'
import moment from 'moment';

Vue.config.productionTip = false

import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);

moment.locale('de')

new Vue({
  store,
  render: h => h(App),
  beforeCreate() {
    this.$store.commit('initialiseStore');
  }
}).$mount('#app')
